// Canonical fuel types in priority order: a combo such as "PETROL/CNG" resolves to the first match.
const FUEL_TYPE_MATCHERS = [
  ['diesel', /diesel/],
  ['petrol', /petrol/],
  ['cng', /cng/],
  ['lng', /lng/],
  ['ev', /(^|[^a-z])ev([^a-z]|$)|electric/]
]

// Vahan returns inconsistent fuel descriptions (e.g. "DIESEL/HYBRID", "CNG ONLY", "ELECTRIC(BOV)").
// Values that match none of the canonical types (e.g. "NA", "WHITE") are returned unchanged.
function normalizeFuelType(fuelType) {
  if (typeof fuelType !== 'string') return fuelType
  const value = fuelType.trim().toLowerCase()
  const match = FUEL_TYPE_MATCHERS.find(([, pattern]) => pattern.test(value))
  return match ? match[0] : fuelType
}

export default normalizeFuelType



// WEBPACK FOOTER //
// ./src/utils/normalizeFuelType.js